module.exports = __webpack_public_path__ + "img/ZAF.458366a7.svg";